/**
 * Luxury Hero Slider JavaScript Component
 * OnlyPaithani - Impulse Theme
 */
(function() {
  'use strict';

  class LuxuryHeroSlider {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.swiperEl = container.querySelector('.swiper');
      this.swiperInstance = null;

      if (!this.swiperEl) return;

      this.initSwiper();
    }

    async initSwiper() {
      // Ensure Swiper library is loaded
      await this.ensureSwiperLoaded();

      if (typeof window.Swiper === 'undefined') {
        console.error('LuxuryHeroSlider: Swiper library failed to load.');
        return;
      }

      const autoplaySetting = this.container.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(this.container.dataset.autoplaySpeed, 10) || 5000;
      const effect = this.container.dataset.effect || 'fade';
      const showNav = this.container.dataset.showNav === 'true';
      const showPag = this.container.dataset.showPag === 'true';

      const swiperConfig = {
        loop: true,
        speed: 800,
        effect: effect,
        fadeEffect: {
          crossFade: true
        },
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        a11y: {
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          firstSlideMessage: 'This is the first slide',
          lastSlideMessage: 'This is the last slide',
        }
      };

      if (autoplaySetting) {
        swiperConfig.autoplay = {
          delay: autoplaySpeed,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      if (showPag) {
        const pagEl = this.container.querySelector('.swiper-pagination');
        if (pagEl) {
          swiperConfig.pagination = {
            el: pagEl,
            clickable: true,
          };
        }
      }

      if (showNav) {
        const nextEl = this.container.querySelector('.swiper-button-next');
        const prevEl = this.container.querySelector('.swiper-button-prev');
        if (nextEl && prevEl) {
          swiperConfig.navigation = {
            nextEl: nextEl,
            prevEl: prevEl,
          };
        }
      }

      // Initialize Swiper
      this.swiperInstance = new window.Swiper(this.swiperEl, swiperConfig);
    }

    ensureSwiperLoaded() {
      if (window.Swiper) return Promise.resolve();

      return new Promise((resolve, reject) => {
        // Load Swiper CSS if not present
        if (!document.querySelector('link[href*="swiper-bundle"]')) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
          document.head.appendChild(link);
        }

        // Load Swiper JS if not present
        if (document.querySelector('script[src*="swiper-bundle"]')) {
          const checkInterval = setInterval(() => {
            if (window.Swiper) {
              clearInterval(checkInterval);
              resolve();
            }
          }, 50);
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load Swiper script'));
        document.head.appendChild(script);
      });
    }

    destroy() {
      if (this.swiperInstance && typeof this.swiperInstance.destroy === 'function') {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }
  }

  function initLuxuryHeroSliders() {
    const containers = document.querySelectorAll('.luxury-hero-slider');
    containers.forEach(container => {
      if (!container.dataset.heroInitialized) {
        container.dataset.heroInitialized = 'true';
        // Store instance on the DOM element so Theme Editor hooks can reach it
        container._heroSlider = new LuxuryHeroSlider(container);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLuxuryHeroSliders);
  } else {
    initLuxuryHeroSliders();
  }

  // Shopify Theme Editor Hooks
  document.addEventListener('shopify:section:load', function(event) {
    const container = event.target.querySelector('.luxury-hero-slider');
    if (container) {
      container.dataset.heroInitialized = 'true';
      container._heroSlider = new LuxuryHeroSlider(container);
    }
  });

  document.addEventListener('shopify:section:select', function(event) {
    const container = event.target.querySelector('.luxury-hero-slider');
    const slider = container && container._heroSlider;
    if (slider && slider.swiperInstance) {
      slider.swiperInstance.autoplay.stop();
    }
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    const container = event.target.querySelector('.luxury-hero-slider');
    const slider = container && container._heroSlider;
    if (slider && slider.swiperInstance && container.dataset.autoplay === 'true') {
      slider.swiperInstance.autoplay.start();
    }
  });
})();
